export type RfiStatus = 'Open' | 'Answered' | 'Closed' | 'Void';

export interface Rfi {
  id?: number;
  projectId: number;
  rfiNumber: string;
  subject: string;
  description: string;
  submittedBy: string;
  submittedTo: string;
  dateSubmitted: string;
  dateRequired: string;
  dateAnswered?: string;
  answer?: string;
  status: RfiStatus;
  ballInCourt: string;
  costImpact: number;
  scheduleImpactDays: number;
  createdAt?: string;
  updatedAt?: string;
}

export const RFI_STATUSES: RfiStatus[] = ['Open', 'Answered', 'Closed', 'Void'];
